<template>
  <div
    class="modal"
    :class="{ isShow: show, isDark: dark }"
    @click="closeModal"
    @keyup.esc="closeEsc"
  >
    <modal-close v-if="show" :show="show" :isActive="showBtn" @close="closeEsc">
      <div class="modal__body" @click.stop>
        <slot></slot>
      </div>
    </modal-close>
  </div>
</template>

<script>
import modalClose from './modalClose'

export default {
    props: {
        show: {
            required: true,
            default: false,
            type: Boolean,
        },
        showBtn: {
            required: false,
            default: true,
            type: Boolean,
        },
        dark: {
            required: false,
            default: false,
            type: Boolean,
        },
        outside: {
            required: false,
            default: false,
            type: Boolean,
        },
    },
    components: {
        modalClose,
    },
    data() {
        return {
            modalShow: this.show,
        }
    },
    methods: {
        closeModal() {
            if (this.outside !== false) {
                const specifiedElement = document.querySelector('.modal__body')
                const isClickInside = specifiedElement.contains(event.target)
                if (!isClickInside) {
                    this.$emit('close')
                }
            }
        },
        closeEsc() {
            this.$emit('close')
        },
    },
}
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  width: 100vw;
  justify-content: center;
  align-items: center;
  transition: 0.5s;
  opacity: 0;
  overflow: hidden;
  display: none;
  animation: showIn 0.3s ease-in;
  user-select: text;
  // z-index: 9999999999 !important;

  &__body {
    width: 100%;
    // max-width: 440px;
    border-radius: 8px;
    box-shadow: 0 16px 24px 0 rgba(0, 0, 0, 0.24);
    // margin: 15px;
    // padding: 40px;
  }
}
.isShow {
  opacity: 1;
  display: flex;
}

@keyframes showIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.isDark {
  z-index: 999;

  // &::before {
  //   position: absolute;
  //   content: "";
  //   left: 0;
  //   right: 0;
  //   bottom: 0;
  //   top: 0;
  //   width: 20px;
  //   height: 20px;

  background: rgba(30, 33, 39, 0.4);
  // }
}

@keyframes showModalAmin {
  0% {
    background-color: rgba(0, 0, 0, 0);
  }
  // 95%{
  //   opacity: 0;
  // }
  100% {
    background-color: rgba(0, 0, 0, 0.35);
  }
}
</style>
